var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"type":"date","range":true,"default-value":_vm.range,"valueType":"date","format":_vm.format,"clearable":false},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})}
var staticRenderFns = []

export { render, staticRenderFns }